import type { ISiteCurtailmentConfigurationFilters } from '@/types/eos/filters'
import type { ISiteCurtailmentConfigurationUpsertForm } from '@/types/eos/forms'
import type { ISiteCurtailmentConfiguration } from '@/types/eos/SiteCurtailmentConfiguration'
import type { IPage } from '@/types/shared/pagination'
import axios from 'axios'

export async function getSiteCurtailmentConfigurations(
  filters: ISiteCurtailmentConfigurationFilters
): Promise<IPage<ISiteCurtailmentConfiguration>> {
  const res = await axios.get(import.meta.env.VITE_APP_SITE_CURTAILMENT_CONFIGURATIONS_ENDPOINT, {
    params: filters,
  })

  return res.data
}

export async function deleteSiteCurtailmentConfiguration(id: number): Promise<any> {
  const res = await axios.delete(`${import.meta.env.VITE_APP_SITE_CURTAILMENT_CONFIGURATIONS_ENDPOINT}/${id}`)
  return res.data
}

export async function createSiteCurtailmentConfiguration(form: ISiteCurtailmentConfigurationUpsertForm): Promise<any> {
  const res = await axios.post(import.meta.env.VITE_APP_SITE_CURTAILMENT_CONFIGURATIONS_ENDPOINT, form)
  return res.data
}

export async function updateSiteCurtailmentConfiguration(
  id: number,
  form: ISiteCurtailmentConfigurationUpsertForm
): Promise<any> {
  const res = await axios.put(`${import.meta.env.VITE_APP_SITE_CURTAILMENT_CONFIGURATIONS_ENDPOINT}/${id}`, form)
  return res.data
}
